module.exports = __webpack_public_path__ + "img/4@2x.3768caf5.png";